import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 全局设置弹框默认点击遮罩层不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false; 

// 导入全局样式表
import './assets/css/global.css'

// 导入字体图标
import './assets/fonts/iconfont.css'
//import VueResource from 'vue-resource'
Vue.use(ElementUI);

//Vue.use(VueResource);
import axios from 'axios'
Vue.prototype.$http = axios
//axios.defaults.withCredentials=true  //开启发送cookie

//import VueCookies from 'vue-cookies'
//Vue.use(VueCookies)
//import { plugin } from 'echarts-for-vue';
//import * as echarts from 'echarts';
//Vue.use(plugin, { echarts });    

//import BaiduMap from 'vue-baidu-map'

//Vue.use(BaiduMap, {
  /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
  //ak: 'bDuL87VCUosIdMAPf9K0XRw71'
//})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
